<script lang="ts">
  import Sidebar from '@clevver/components/sidebar/sidebar.vue'
  import Header from '@clevver/components/header/header.vue'
  import Modal from '@clevver/components/modal.vue'
  import MobileTabBar from '@clevver/components/dashboard/mobile-tab-bar.vue'
  import FacetSheet from '@clevver/components/dashboard/facet-sheet.vue'

  import { useUserStore } from '@clevver/stores/user.store'
  import { useFilesStore } from '@clevver/stores/files.store'
  import { useThemeStore } from '@clevver/stores/theme.store'

  import { RouterView } from 'vue-router'
  import { defineComponent, onMounted, ref } from 'vue'

  import { clevverEmitter } from '@clevver/stores/event.store'
  import { useToast } from 'vue-toastification'

  export default defineComponent({
    name: 'App',
    components: { Sidebar, Header, RouterView, Modal, MobileTabBar, FacetSheet },

    setup() {
      const userStore = useUserStore()
      const filesStore = useFilesStore()
      const themeStore = useThemeStore()
      const toast = useToast()
      const sheetOpen = ref(false)

      clevverEmitter.on('requestFailed', (data: any) => toast.error(data.message))
      clevverEmitter.on('requestSuccess', (data: any) => toast.success(data.message))

      onMounted(() => {
        userStore.fetchUser()
        themeStore.setMode(themeStore.mode) // sync document on load
        filesStore.fetchQuota()

        // Keep the quota roughly accurate across devices/sessions.
        setInterval(() => filesStore.fetchQuota(), 60000)
      })

      return { userStore, themeStore, sheetOpen }
    }
  })
</script>

<template>
  <div v-if="!userStore.user" class="dashboard dashboard--loading" :data-bs-theme="themeStore.mode">
    <span class="dashboard__loading">Loading…</span>
  </div>

  <div v-else class="dashboard" :data-bs-theme="themeStore.mode">
    <Header />
    <div class="dashboard__body">
      <Sidebar />
      <main class="dashboard__main">
        <RouterView />
      </main>
    </div>

    <MobileTabBar @filter="sheetOpen = true" />
    <FacetSheet :open="sheetOpen" @close="sheetOpen = false" />
    <Modal />
  </div>

  <div data-tf-sidetab="fLc9pTHG" data-tf-opacity="100" data-tf-iframe-props="title=Clevver.org Support Form" data-tf-transitive-search-params data-tf-button-color="#D65C99" data-tf-button-text="Need help?" data-tf-medium="snippet" style="all:unset;"></div>
</template>

<style lang="scss">
  #clevver { display: block; }
</style>
